export { default as isInClientStoreEnabled } from './selectors/isInClientStoreEnabled';
export { default as isPinnableExperienceEnabled } from './selectors/isPinnableExperienceEnabled';
export { default as isPersistentTaskpaneEnabled } from './selectors/isPersistentTaskpaneEnabled';
export {
    default as isAddinComplianceVerificationEnabled,
} from './selectors/isAddinComplianceVerificationEnabled';
